import { useContactSupport } from '@/hooks/useContactSupport';
import { Button, type ButtonProps } from '@design-system';
import { MessageCircle } from 'lucide-react';

interface ContactSupportButtonProps extends Omit<ButtonProps, 'onClick'> {
  subject: string;
  fallbackEmail?: string;
  children?: React.ReactNode;
}

export function ContactSupportButton({
  subject,
  fallbackEmail,
  children = 'Contact Support',
  variant = 'outline',
  className,
  ...buttonProps
}: ContactSupportButtonProps) {
  const handleContactSupport = useContactSupport({
    subject,
    fallbackEmail,
  });

  return (
    <Button
      variant={variant}
      onClick={handleContactSupport}
      className={className}
      {...buttonProps}
    >
      <MessageCircle />
      {children}
    </Button>
  );
}
